/** Shared hero CTA visibility & fallback (labels/URLs live on site_settings). */
export const HERO_ACTIONS_DEFAULTS = {
  /** When label or URL is blank: `sort_order` = first two categories; `rakhi_lumba` = rakhi + lumba slugs */
  fallback: 'sort_order',
  show_primary_home: true,
  show_secondary_home: true,
  show_primary_shop: true,
  show_secondary_shop: true,
  show_primary_about: true,
  show_secondary_about: true,
};
